import { v4 as uuidv4 } from 'uuid';

export function CheckoutSummaryTotalizers(props = {}, childrenComponents = [], blocks = []) {
	return {
		componentName: 'CheckoutSummaryTotalizers',
		componentId: uuidv4(),
		props: Object.assign(
			{
				showTotal: true,
				showDeliveryTotal: true,
			},
			props,
		),
		childrenComponents,
	};
}
